import zhloc from 'element-ui/lib/locale/lang/zh-CN'

export default {
  main:{
    message:"消息",
    display:"展示"
  },
  ...zhloc
};


// WEBPACK FOOTER //
// ./src/lang/zn.js